module.exports = __webpack_public_path__ + "static/media/floor_ne2.6d8afa69.png";